import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-30px <lg:text-14px pl-7px font-400 mb-15px <xl:mb-6px" }
const _hoisted_2 = { class: "lowercase inline-block text-30px <lg:text-14px <lg:leading-14px <lg:transform <lg:-translate-y-4px text-white leading-30px" }
const _hoisted_3 = { class: "text-48px <lg:text-20px pl-5px uppercase horiz-center font-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flying_span = _resolveComponent("flying-span")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_flying_span, { timeout: 300 }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Зарабатывайте с нами")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_flying_span, {
      block: "",
      timeout: 600,
      class: _normalizeClass(["mb-15px <sm:mb-6px", { flip: _ctx.isFlipping }])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["inline-block bg-hex-6664D6 whitespace-nowrap <lg:h-20px h-36px px-8px pb-4px", { flip: _ctx.isFlipping }])
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.message), 1)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "inline-block h-48px <lg:h-20px ml-10px border border-l-black animate-input-bar" }, null, -1))
    ])
  ], 64))
}